import * as ActionTypes from './actionTypes.js';
import _ from 'lodash';

const initialState = {
    showStandardBanner: false,
};

export default function quotesReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.QUOTES_AGENTLIST_FETCH_SUCCESS:
        case ActionTypes.QUOTES_AGENTLIST_FETCH_FAILED:
        case ActionTypes.QUOTES_AGENTLIST_LOADING:
        case ActionTypes.QUOTES_SG_MIGRATION_TABLE:
        case ActionTypes.SHOW_HIDE_STANDARD_BANNER:    
            return _.extend({}, state, action.payload);
        default:
            return state;
    }
}